import { render } from "./EditButtonModal.vue?vue&type=template&id=610fab42"
import script from "./EditButtonModal.vue?vue&type=script&lang=js"
export * from "./EditButtonModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__